import React from "react";
import { MdCheck } from "react-icons/md";
import Card, { CardHeader } from "components/card";
import ColorField from "./ColorField";
import FontPicker from "./FontPicker";
import { PRESET_COLORS } from "./constants";

const cx = (...classes) => classes.filter(Boolean).join(" ");

const BrandingSection = ({
  backgroundColor,
  displayNameColor,
  taglineColor,
  headingFont,
  bodyFont,
  displayName,
  onFieldChange,
}) => {
  const selectedBackground = backgroundColor.toLowerCase();

  return (
    <>
      <Card padding="md" className="gap-5">
        <CardHeader title="Background Color" />
        <div
          role="group"
          aria-label="Preset background colors"
          className="grid grid-cols-4 gap-3 sm:grid-cols-8"
        >
          {PRESET_COLORS.map((color) => {
            const selected = selectedBackground === color.value.toLowerCase();
            return (
              <button
                key={color.value}
                type="button"
                aria-label={color.name}
                aria-pressed={selected}
                title={color.name}
                onClick={() => onFieldChange("backgroundColor", color.value)}
                className={cx(
                  "focus-ring flex h-12 w-full items-center justify-center rounded-control border-2 transition-colors",
                  selected ? "border-primary" : "border-line hover:border-fg-muted"
                )}
                style={{ backgroundColor: color.value }}
              >
                {selected && <MdCheck aria-hidden="true" className="h-5 w-5 text-brand-700" />}
              </button>
            );
          })}
        </div>
        <ColorField
          label="Custom Color"
          value={backgroundColor}
          onChange={(value) => onFieldChange("backgroundColor", value)}
          placeholder="#F5F2E9"
          className="sm:max-w-xs"
        />
      </Card>

      <Card padding="md" className="gap-5">
        <CardHeader title="Text Colors" />
        <div className="grid gap-5 sm:grid-cols-2">
          <ColorField
            label="Display Name Color"
            value={displayNameColor}
            onChange={(value) => onFieldChange("displayNameColor", value)}
            placeholder="#000000"
          />
          <ColorField
            label="Tagline Color"
            value={taglineColor}
            onChange={(value) => onFieldChange("taglineColor", value)}
            placeholder="#6B7280"
          />
        </div>
      </Card>

      <Card padding="md" className="gap-5">
        <CardHeader title="Typography" />
        <div className="grid gap-5 sm:grid-cols-2">
          <FontPicker
            label="Heading Font"
            value={headingFont}
            onChange={(value) => onFieldChange("headingFont", value)}
            previewText={displayName || "Your Church Name"}
          />
          <FontPicker
            label="Body Font"
            value={bodyFont}
            onChange={(value) => onFieldChange("bodyFont", value)}
            previewText="Links and body text will use this font"
          />
        </div>
      </Card>
    </>
  );
};

export default BrandingSection;
